/** Safari private browsing and strict modes can throw on localStorage access. */

function storageAvailable(): boolean {
    try {
        const key = '__storage_test__';
        localStorage.setItem(key, '1');
        localStorage.removeItem(key);
        return true;
    } catch {
        return false;
    }
}

const canUseLocalStorage = typeof window !== 'undefined' && storageAvailable();

export const safeLocalStorage = {
    getItem(key: string): string | null {
        if (!canUseLocalStorage) return null;
        try {
            return localStorage.getItem(key);
        } catch {
            return null;
        }
    },
    setItem(key: string, value: string): void {
        if (!canUseLocalStorage) return;
        try {
            localStorage.setItem(key, value);
        } catch {
            // Ignore quota / private-mode errors.
        }
    },
    removeItem(key: string): void {
        if (!canUseLocalStorage) return;
        try {
            localStorage.removeItem(key);
        } catch {
            // Ignore.
        }
    },
};
